import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import NavButtons from 'components/Software/macOS/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "InstarVision v3 für macOS",
  "path": "/Software/macOS/InstarVision/Advanced/Log/",
  "dateChanged": "2018-01-25",
  "author": "Mike Polinowski",
  "excerpt": "Überprüfen Sie das Logbuch um potentielle Probleme zu sichten",
  "image": "../../P_SearchThumb_InstarVision_Windows.png",
  "social": "/images/Search/P_SearchThumb_InstarVision_Windows.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Windows-InstarVision_white.webp",
  "chapter": "Software"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='InstarVision v3 für macOS' dateChanged='2018-01-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='Das InstarVision Surveillance Center ist eine IP-Kamera-Software, die 64 Kameras gleichzeitig unterstützen kann, einschließlich Netzwerkkameras, USB-Kameras mit Fernzugriff und Sekundärinstallationen der Software.' image='/images/Search/P_SearchThumb_InstarVision_Windows.png' twitter='/images/Search/P_SearchThumb_InstarVision_Windows.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Software/macOS/InstarVision/Advanced/Log/' locationFR='/fr/Software/macOS/InstarVision/Advanced/Log/' crumbLabel="Log" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <p><img parentName="p" {...{
        "src": "../Banner_en-InstarVision2-0_Advanced.png",
        "alt": "InstarVision v3 for Windows"
      }}></img></p>
    <h2 {...{
      "id": "system-log",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-log",
        "aria-label": "system log permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Log`}</h2>
    <p><strong parentName="p">{`Überprüfen Sie das Logbuch um potentielle Probleme zu sichten`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/3c4d629f9b55abdee52b4984321e6ad2/c929c/de_advanced_log.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "57.826086956521735%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAADSklEQVQoz02SbU+TBxiFn1+zD1sypx0sROugIFFgOGFuIlDjFLZIGFgmpcCQtdBWB5HSggpMYFmwLSw4qQxZYJo4gmRix/regtMUKK+Cc5Q+bb0W65fdycl9Pl05OTnCrDuI9+9Vni4/Z/5ZiKmZWWbsbuzepYS6bwfoHPbTM/wX3UOzKFonKG/9nYp2O2f109Rde4Tb6cRqseD3+hB6B3/hu45evreMMDQ2RWm5gqp6Nf0/3UXfZuJkWQt5ZZ3klBjJlF/i/ZwLSHKUpMlbOVb7G2Vtj7GYzRgMBmwjtxGkqQcoKCog/3g+xaflaHQ6bKN3sN2xYbXexDx4C8vwOGP3HjE6+ZBbYw8YGX/ApyUKJJnF5J5Rc6OvH7PVyk2zGeFobjbZWZnI0qWkyVJQqi6wHAoRDAYJBhdZWlxkc2ON3fC//P8qq1W8LdlPdl4BPUYDP1wz0dfdhXDkkIyaqgoqKiopOnmCulol/sA8Xq8Xl8uJ3+9PyOv1sbW1TUQUEcUoWm0j2VnplFWpqB2apHRggu7RewhHs/Zz6rPDnC3M4qOMJBpV55lfWCAQ8OPxeBJgh8PB6toaYgImEovFMZmMFBUXo7h4Cf1CjM/nIoyvRhHUze1otB2o6vQolVo6uwYJzAcSqVwuVwL6+m9vvyAejxOORBBjMa73mskvrkRR20Sr6zmV9m3uPttGaG6x0Ga0odMPUN9wg57+X3F7PPh8Pux2Oy6nM+HX19cJ7+5CPArRXRzOp9yfecLP930o7FvkTG0x+OQFQu4nx8k5Jif3xDlSPy6kokHL5sY6a6srrIRWWFwKsRxaYW1jEzEcZnpDxBqKo7/SSUmRHG1TMy93Rf6JRHm5E0bQdFynxmBE2WbiC107jX0Wpuc82MYmeDw3i/PPh3jmZvA5ZnHb/8A0aadqzIHusg7tl3l0fVuOGIkQi4qEd3YQmkwX0VzV8o1JzfmWeqovq9Foqjl3Jp/GmtO0N8tpbSikS19Kv0GFUVvHVb2SgStf0as5xY9tX/Pq1ZspRaNRhGTpHpIPSkiS7uXD9BQyUlM4kpbEIel7ZEj3kXpwHx8kvcOBlHdJk+7lsCyZjFQJMukepElvkZcrw+1+0/nrRfwHCo+55hYekNUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/3c4d629f9b55abdee52b4984321e6ad2/e4706/de_advanced_log.avif 230w", "/de/static/3c4d629f9b55abdee52b4984321e6ad2/d1af7/de_advanced_log.avif 460w", "/de/static/3c4d629f9b55abdee52b4984321e6ad2/7f308/de_advanced_log.avif 920w", "/de/static/3c4d629f9b55abdee52b4984321e6ad2/203bb/de_advanced_log.avif 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/3c4d629f9b55abdee52b4984321e6ad2/a0b58/de_advanced_log.webp 230w", "/de/static/3c4d629f9b55abdee52b4984321e6ad2/bc10c/de_advanced_log.webp 460w", "/de/static/3c4d629f9b55abdee52b4984321e6ad2/966d8/de_advanced_log.webp 920w", "/de/static/3c4d629f9b55abdee52b4984321e6ad2/491b1/de_advanced_log.webp 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/3c4d629f9b55abdee52b4984321e6ad2/81c8e/de_advanced_log.png 230w", "/de/static/3c4d629f9b55abdee52b4984321e6ad2/08a84/de_advanced_log.png 460w", "/de/static/3c4d629f9b55abdee52b4984321e6ad2/c0255/de_advanced_log.png 920w", "/de/static/3c4d629f9b55abdee52b4984321e6ad2/c929c/de_advanced_log.png 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/3c4d629f9b55abdee52b4984321e6ad2/c0255/de_advanced_log.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Das Log Fenster gibt Ihnen eine Übersicht über die laufenden Operationen der Software - und Fehler, die dabei auftreten. Wann haben Sie den Kontakt zu Ihrer Kamera verloren? Vermissen Sie eine Videoaufnahme, obwohl die InstarVision eine Alarm-Aufnahme registriert hat? Wählen Sie welche Informationen Sie sichten möchten - Systemereignisse, Aufnahmen, Netzwerkfunktionen, Setup oder Bewegungsalarme. Wählen Sie noch das Zeitfenster, dass Sie interessiert, und klicken Sie den Suche Button. Für erfahrene User: Die Log Datei wird im Installationsverzeichnis der Software gespeichert und kann für manuelle - oder gescriptete - Backups genutzt werden.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      